import React               from "react";
import { Typography }      from "@material-ui/core";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faTruckLoading }  from "@fortawesome/pro-solid-svg-icons/faTruckLoading";
import history             from "@history";
import NotificationBase    from "app/main/genericComponents/notification/NotificationBase";

export function TipUpdated(props) {

    return (
        <NotificationBase
            content={<Typography className={"align-middle"}>
                <FontAwesomeIcon icon={faTruckLoading}/>
                {" Le conseil " + props.infos.name + " a été mit à jour. "}
            </Typography>}
            onRedirect={() => history.push("/conseils")}
            notification={props}
        />
    );
}


